import { DataSecurityAppUser } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAppUsersRequest = {
	filter?: string;
};

export const getDataSecurityAppUsers = createGetEndpoint<GetDataSecurityAppUsersRequest, Array<DataSecurityAppUser>>(
	(request) => `/api/v3/data-security/organization/salesforce-users?${getQueryString(request)}`
);
